const SLEEPY_VENDOR_NAME = 'Sleepy';
const GIFT_VARIANT_ID = 40735708708934;
const PRODUCT_TYPE = 'Mattresses';

const handleGiftLogic = (Cart, variantId, vendorName, secondVendorName) => {
  const items = Cart.getItems();
  let giftQty = 0;

  const sleepyItems = secondVendorName
    ? items.filter(
        (item) =>
          (item.vendor === vendorName || item.vendor === secondVendorName) &&
          item.id !== variantId &&
          item.product_type === PRODUCT_TYPE &&
          item.product_id != 7541332475974
      )
    : items.filter(
        (item) =>
          item.vendor === vendorName &&
          item.id !== variantId &&
          item.product_type === PRODUCT_TYPE &&
          item.product_id != 7541332475974
      );

  const singleSizeMattresses = sleepyItems.filter((item) => +item.variant_title.split('/')[0] <= 120);
  const doubleSizeMattresses = sleepyItems.filter((item) => +item.variant_title.split('/')[0] > 120);

  const giftItem = items.find((item) => item.variant_id === variantId);
  const hasGift = Boolean(giftItem);

  for (const item of singleSizeMattresses) {
    giftQty += item.quantity;
  }

  for (const item of doubleSizeMattresses) {
    giftQty += item.quantity * 2;
  }

  if (giftQty !== (giftItem?.quantity || 0)) {
    Cart.changeItem({
      id: variantId,
      quantity: giftQty,
    });
  }

  if (!hasGift && giftQty > 0) {
    Cart.addItem({
      id: variantId,
      quantity: giftQty,
    });
  }
};

document.addEventListener('rebuy:cart.ready', (event) => {
  const Cart = window.Rebuy.Cart;

  //General Gift
  const giftItem = Cart.getItems().find((item) => item.variant_id === GIFT_VARIANT_ID);
  const cartPageQuantity = giftItem
    ? document.querySelector(`.cart__item[data-variant-id="${giftItem.variant_id}"] .quantity`)
    : null;

  if (cartPageQuantity) {
    cartPageQuantity.value = giftItem.quantity;
  }

  handleGiftLogic(Cart, GIFT_VARIANT_ID, SLEEPY_VENDOR_NAME);

  document.addEventListener('rebuy:cart.change', (event) => {
    handleGiftLogic(Cart, GIFT_VARIANT_ID, SLEEPY_VENDOR_NAME);
  });
});
